import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";

import Landing from "@/pages/Landing";
import Portal from "@/pages/Portal";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Goals from "@/pages/Goals";
import Leaderboard from "@/pages/Leaderboard";
import Liga from "@/pages/Liga";
import Academy from "@/pages/Academy";
import CRM from "@/pages/CRM";
import Onboarding from "@/pages/Onboarding";
import Profile from "@/pages/Profile";
import MasterOverview from "@/pages/MasterOverview";
import CoachPanel from "@/pages/CoachPanel";
import Billing from "@/pages/Billing";
import Branding from "@/pages/Branding";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Portal />} />
            <Route path="/league" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/registar" element={<Register />} />
            <Route
              path="/app"
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="liga" element={<Liga />} />
              <Route path="objetivos" element={<Goals />} />
              <Route path="ranking" element={<Leaderboard />} />
              <Route path="academia" element={<Academy />} />
              <Route path="perfil" element={<Profile />} />
              <Route
                path="rede"
                element={
                  <ProtectedRoute roles={["master", "admin"]}>
                    <MasterOverview />
                  </ProtectedRoute>
                }
              />
              <Route
                path="coaching"
                element={
                  <ProtectedRoute roles={["coach"]}>
                    <CoachPanel />
                  </ProtectedRoute>
                }
              />
              <Route
                path="crm"
                element={
                  <ProtectedRoute roles={["admin", "agency_manager"]}>
                    <CRM />
                  </ProtectedRoute>
                }
              />
              <Route
                path="faturacao"
                element={
                  <ProtectedRoute roles={["admin", "agency_manager"]}>
                    <Billing />
                  </ProtectedRoute>
                }
              />
              <Route
                path="marca"
                element={
                  <ProtectedRoute roles={["agency_manager"]}>
                    <Branding />
                  </ProtectedRoute>
                }
              />
              <Route path="onboarding" element={<Onboarding />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
